export const NODE_DEPLOYER_ABI = [
  {
    inputs: [{ internalType: 'address', name: '_factory', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  { inputs: [], name: 'DeployNodeFail', type: 'error' },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'nonce',
        type: 'uint256',
      },
    ],
    name: 'IncreaseNonce',
    type: 'event',
  },
  {
    inputs: [
      { internalType: 'address', name: '_expectAddress', type: 'address' },
      { internalType: 'bytes', name: 'initData', type: 'bytes' },
    ],
    name: 'deploy',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nonce',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
];
